import React from 'react';
import Close from "../../icons/close.svg";
import RequestIcon from "../../icons/request.svg";
import './HelpPopup.styles.scss';

function HelpPopup({ close }) {
    return (
        <div className="help-popup">
            <button
                className="help-popup__close"
                onClick={close}
            >
                <Close />
            </button>
            <div className="help-popup__logo"><RequestIcon /></div>
            <div className="help-popup__title">Thank you, your request has been sent. <br/>Charlie will reply as soon as possible.</div>

        </div>
    );
}

export default HelpPopup;